module.exports = __webpack_public_path__ + "img/3.ab4819fe.png";